import React from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";

const VehicleDetailsModal = ({ show, toggle, vehicle }) => {
  if (!vehicle) return null; // If vehicle is null, don't render


  return (
    <Modal isOpen={show} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Vehicle Details</ModalHeader>

      <ModalBody>
        <div className="p-2">
          {/* Basic Info */}
          <h6 className="border-bottom pb-2 mb-3">Basic Information</h6>
          <Row className="gy-2">
            <Col md={6}>
              <strong>Vehicle Name: </strong> {vehicle.vehicleName || "-"}
            </Col>
            <Col md={6}>
              <strong>Vehicle No: </strong> {vehicle.vehicleNo || "-"}
            </Col>
            <Col md={6}>
              <strong>Model No: </strong> {vehicle.vehicleModelNo || "-"}
            </Col>
            <Col md={6}>
              <strong>Capacity: </strong> {vehicle.vehicleCapacity || "-"}
            </Col>
            <Col md={6}>
              <strong>Capacity Unit: </strong> {vehicle.capacityUnit || "-"}
            </Col>
          </Row>

          {/* Rates */}
          <h6 className="border-bottom pb-2 my-3">Rates</h6>
          <Row className="gy-2">
            <Col md={6}>
              <strong>KM Rate: </strong> {vehicle.kmRate || "-"}
            </Col>
            <Col md={6}>
              <strong>Local Rate: </strong> {vehicle.localRate || "-"}
            </Col>
          </Row>

          {/* Documents */}
          <h6 className="border-bottom pb-2 my-3">Documents</h6>
          <Row className="gy-2">
            <Col md={6}>
              <strong>PUC Start Date: </strong> {vehicle.pucStartDate || "-"}
            </Col>
            <Col md={6}>
              <strong>PUC End Date: </strong> {vehicle.pucEndDate || "-"}
            </Col>

            <Col md={6}>
              <strong>Insurance Start Date: </strong>{" "}
              {vehicle.insuranceStartDate || "-"}
            </Col>
            <Col md={6}>
              <strong>Insurance End Date: </strong>{" "}
              {vehicle.insuranceEndDate || "-"}
            </Col>

            <Col md={6}>
              <strong>Road Tax Start Date: </strong>{" "}
              {vehicle.roadTaxStartDate || "-"}
            </Col>
            <Col md={6}>
              <strong>Road Tax End Date: </strong>{" "}
              {vehicle.roadTaxEndDate || "-"}
            </Col>
          </Row>

          {/* Image */}
          {vehicle?.imageUrl && (
            <>
              <h6 className="border-bottom pb-2 my-3">Vehicle Image</h6>
              <img
                src={vehicle.imageUrl}
                alt="Vehicle"
                className="img-fluid rounded shadow-sm"
                style={{ maxWidth: "220px" }}
              />
            </>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VehicleDetailsModal;
